import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';

export const uiAutoplayOptionsStore = Store.createStore({
    disabledLimits: Store.signal(false),
    autoplayValues: Store.signal([] as number[]),
    defaultSpins: Store.signal(0),
    showOptionsPopup: slotStore.isAutoplayOptionsPopup,
    quickSpin: Store.computed(() => slotStore.reelsSpeedLevel.value === ReelsSpeedLevel.turbo_1),
    turboSpin: Store.computed(() => slotStore.reelsSpeedLevel.value === ReelsSpeedLevel.turbo_2),
    untilBonus: slotStore.feature_autoplayUntilBonusEnabled,
    singleWin: Store.signal(null as number | null),
    winLimit: Store.signal(null as number | null),
    lossLimit: Store.signal(null as number | null)
});